import React, { memo } from 'react';
import useMedia from 'use-media';

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from 'recharts';

import styles from './graph.module.scss';
import { UsequestionsState } from '@/store/atoms/questionsState';

export const Graph = memo(({ byCatSum }) => {
  // const isMobileScreen = useMediaQuery({ query: '(max-width: 768px)' });
  const isMobileScreen = useMedia({ maxWidth: '768px' });

  const { rate, catList } = UsequestionsState();
  console.log('rate', rate);
  const graphRate = rate * 5;
  let data = [];

  if (byCatSum.length) {
    data = [
      {
        section: catList[0].name,
        A: Math.ceil(byCatSum[0].sum * graphRate),
        fullMark: 100,
      },
      {
        section: catList[1].name,
        A: Math.ceil(byCatSum[1].sum * graphRate),
        fullMark: 100,
      },
      {
        section: catList[2].name,
        A: Math.ceil(byCatSum[2].sum * graphRate),
        fullMark: 100,
      },
      {
        section: catList[3] && catList[3].name || '',
        A: Math.ceil(byCatSum[3].sum * graphRate),
        fullMark: 100,
      },
      {
        section: catList[4].name,
        A: Math.ceil(byCatSum[4].sum * graphRate),
        fullMark: 100,
      },
    ];
  }
  if (isMobileScreen) {
    return (
      <div className={styles.graph}>
        <RadarChart // レーダーチャート全体の設定を記述
          cx={155} // 要素の左端とチャートの中心点との距離
          cy={120} // 要素の上部とチャートの中心点との距離
          outerRadius={100} // レーダーチャート全体の大きさ
          width={312} // レーダーチャートが記載される幅
          height={220} // レーダーチャートが記載される高さ
          data={data} // 表示対象のデータ
        >
          {/* グラフ線（蜘蛛の巣）の数とその値 */}
          <PolarGrid polarRadius={[20, 40, 60, 80, 100]} stroke='#ccc' />
          <PolarRadiusAxis //メモリ：不要だがないとfullMarkにバグが発生するので必須
            stroke='rgba(1, 1, 1, 0)' //文字の出力を消す為に透明に
            angle={90} // 中心点から水平を0°とした時の角度 垂直にしたいなら90を指定
            domain={[0, 100]} // リストの１番目の要素が最小値、2番目の要素が最大値
          />
          <PolarAngleAxis dataKey='section' />
          <Radar
            name='janken'
            dataKey='A'
            stroke='#4A96E6'
            fill='#4A96E6'
            fillOpacity={0.22}
          />
        </RadarChart>
      </div>
    );
  } else {
    return (
      <div className={styles.graph}>
        <RadarChart // レーダーチャート全体の設定を記述
          cx={170} // 要素の左端とチャートの中心点との距離
          cy={135} // 要素の上部とチャートの中心点との距離
          outerRadius={100} // レーダーチャート全体の大きさ
          width={390} // レーダーチャートが記載される幅
          height={390} // レーダーチャートが記載される高さ
          data={data} // 表示対象のデータ
        >
          {/* グラフ線（蜘蛛の巣）の数とその値 */}
          <PolarGrid polarRadius={[20, 40, 60, 80, 100]} stroke='#ccc' />
          <PolarRadiusAxis //メモリ：不要だがないとfullMarkにバグが発生するので必須
            stroke='rgba(1, 1, 1, 0)' //文字の出力を消す為に透明に
            angle={90} // 中心点から水平を0°とした時の角度 垂直にしたいなら90を指定
            domain={[0, 100]} // リストの１番目の要素が最小値、2番目の要素が最大値
          />
          <PolarAngleAxis dataKey='section' />
          <Radar
            name='janken'
            dataKey='A'
            stroke='#4A96E6'
            fill='#4A96E6'
            fillOpacity={0.22}
          />
        </RadarChart>
      </div>
    );
  }
});
